import React from 'react';
import './MarketplaceTile.scss';
import Sparkles from '../../../../shared/components/sparkles/Sparkles';
import SparklesField from '../../../../shared/components/sparkles/SparklesField';

interface MarketplaceTileProps {
  /** `ico--*` class drawn in the middle of the sparkles: a mask icon or a model logo (`*-bck`, greyed out). */
  icon: string;
  /** CSS colour the icon and sparks take on hover (`--tile-accent`). */
  accent: string;
  title: string;
  description: string;
  features: string[];
  /** Heading of the feature list ("What's included"). */
  includedLabel: string;
  buttonLabel: string;
  /** `ico--*` class shown in the button before the label. */
  buttonIcon: string;
  disabled: boolean;
  onAction: () => void;
}

/** One purchasable offer, laid out like an integrations card; its icon in large grey sparkles as a watermark top-left. */
const MarketplaceTile: React.FC<MarketplaceTileProps> = ({
  icon,
  accent,
  title,
  description,
  features,
  includedLabel,
  buttonLabel,
  buttonIcon,
  disabled,
  onAction,
}) => (
  <div className="marketplace-tile" style={{ '--tile-accent': accent } as React.CSSProperties}>
    <SparklesField />
    <Sparkles icon={icon} className="sparkles--watermark" sparks={8} />
    <div className="marketplace-tile__head">
      <span className="marketplace-tile__title">{title}</span>
    </div>
    <div className="marketplace-tile__desc">{description}</div>

    <div className="marketplace-tile__included">
      <div className="marketplace-tile__included-title">{includedLabel}</div>
      <ul className="marketplace-tile__features">
        {features.map((feature) => (
          <li key={feature} className="marketplace-tile__feature">
            {feature}
          </li>
        ))}
      </ul>
    </div>

    <button
      type="button"
      className="btn btn--sm btn--black marketplace-tile__button"
      onClick={onAction}
      disabled={disabled}
    >
      <span className={`${buttonIcon} ico--xs`} />
      <span>{buttonLabel}</span>
    </button>
  </div>
);

export default MarketplaceTile;
